import * as HttpService from "../../../../service/HttpService"

/**
 * 获取单位资产
 * @param customId 客户id
 */
export const getAssets = (customId) => {
    return HttpService.get(HttpService.DOMAIN + "/viewReResource/getDistributionAssets?custId=" + customId)
}

/**
 * 获取单位电量使用情况
 * @param customId 客户id
 */
export const getPowerUsageCondition = (customId) => {
    return HttpService.get(HttpService.DOMAIN + "/viewStatisticalPower/getCustEconsMonthAndYear?custId=" + customId);
}

/**
 * 获取用电单位运维服务信息
 * @param customId 客户id
 */
export const getOpsInfo = (customId) => {
    return HttpService.get(HttpService.DOMAIN + "/workOrderOvw/getThisMonthWorkNumOfStatByCusId?custId=" + customId);
}


/**
 * 获取用电单位本月告警信息
 * @param customId 客户id
 */
export const getMonthWarningInfo = (customId) => {
    return HttpService.get(HttpService.DOMAIN + "/viewSoeRecord/getSoeRecordListByCustId?custId=" + customId);
}

/**
 *  获取用电单位负荷信息
 * @param customId 客户id
 */
export const getLoadInfo = (customId) => {
    return HttpService.get(HttpService.DOMAIN + "/viewStatisticalPower/getCustLoadsDayAndMonthAndYear?custId=" + customId);
}

/**
 * 获取用电单位功率因素
 * @param customId 客户id
 */
export const getPowerFactor = (customId) => {
    return HttpService.get(HttpService.DOMAIN + "/viewMbCustBill/getPowerFactor?custId=" + customId);
}

/**
 * 获取用电单位电费情况
 * @param customId 客户id
 */
export const getElectricityCharges = (customId,date) => {
    return HttpService.get(HttpService.DOMAIN + "/viewMbCustBill/getElectricityCharges?custId=" + customId+"&date="+date);
}
/**
 * 获取用电单位电量结构
 * @param customId 客户id
 */
export const getElectricityStructure = (customId) => {
    return HttpService.get(HttpService.DOMAIN + "/viewStatisticalPower/getElectricityStructure?custId=" + customId);
};
/* 
负荷信息
*/
export const getLoadTendency = (customId, type) => {
    return HttpService.get(
        HttpService.DOMAIN + "/viewStatisticalPower/getLoadTendency?ceCustId=" + customId + "&type=" + type
    );
};
/**
 * 累计电量
 * @param customId 客户id
 */
export const getlistKwhTendency = (customId, type) => {
    return HttpService.get(
        HttpService.DOMAIN + "/viewHomePageInfo/listKwhTendency?ceCustId=" + customId + "&dateType=" + type
    );
};